import React from 'react';
import DeviceAction from '../actions/device-action';
import {VstButton} from 'vstui';

const Device = (props) => {
  const _onDeactivate = () => {
    DeviceAction.deactivateDevice(props.id);
  };

  return (
    <div className="clear card device" key={`device-line-item-${props.id}`}>
      <div className="left">
        {props.mobile
          ? <img className="device" src={require('../../img/mobile.svg')} alt="mobile" />
          : <img className="device" src={require('../../img/devices.svg')} alt="desktop" />
        }
        <div className="details">
          <span className="title">{props.clientName}</span>
          <span className="computer-name">{props.name}</span>
          <span className="client-version">{props.clientVersion}</span>
          <span className="last-accessed">{props.lastLicenseUpdate}</span>
        </div>
      </div>
      <VstButton className="deactivate" options="btn-36" onClick={_onDeactivate}>{i18n.t('devices.deactivate')}</VstButton>
    </div>
  );
};

export default Device;



/** WEBPACK FOOTER **
 ** ./src/js/components/device.jsx
 **/